"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var toggle_1 = require("msteams-ui-styles-core/lib/components/toggle");

var React = require("react");

var teams_context_1 = require("../teams-context");

var classes_1 = require("../utils/classes");

var ToggleView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToggleView, _React$Component);

  function ToggleView() {
    var _this;

    _classCallCheck(this, ToggleView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToggleView).apply(this, arguments));
    _this.button = null;

    _this.click = function (e) {
      _this.props.onToggle(!_this.props.checked);
    };

    return _this;
  }

  _createClass(ToggleView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRef) {
        this.props.onRef(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.onRef) {
        this.props.onRef(null);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.button) {
        this.button.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          context = _a.context,
          required = _a.required,
          checked = _a.checked,
          className = _a.className,
          children = _a.children,
          onRef = _a.onRef,
          name = _a.name,
          value = _a.value,
          rest = __rest(_a, ["context", "required", "checked", "className", "children", "onRef", "name", "value"]);

      var themeClassNames = toggle_1.toggle(context);
      return React.createElement("div", {
        className: themeClassNames.container
      }, React.createElement("input", {
        "aria-hidden": "true",
        type: "checkbox",
        readOnly: true,
        name: name,
        value: value,
        checked: checked,
        className: themeClassNames.input
      }), React.createElement("button", Object.assign({
        ref: function ref(_ref) {
          return _this2.button = _ref;
        },
        role: "button",
        "aria-required": required,
        "aria-pressed": checked,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: this.click,
        className: classes_1.default(themeClassNames.slider, className)
      }, rest), children));
    }
  }]);

  return ToggleView;
}(React.Component);

exports.Toggle = teams_context_1.connectTeamsComponent(ToggleView);